module.exports = __webpack_public_path__ + "static/img/top.d271ab47.jpg";